import { types } from "../types/types";

const initialState = {
  refunds: [],
  refundActivo: null,
  isLoading: false,
  dashboard: null,
};

export const newRefundReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.newRefundsLoading:
      return {
        ...state,
        refunds: [...action.payload],
        isLoading: false,
      };

    case types.newRefundSetLoading:
      return {
        ...state,
        isLoading: true,
      };

    case types.newRefundSetActive:
      return {
        ...state,
        refundActivo: action.payload,
      };

    case types.newRefundClearActive:
      return {
        ...state,
        refundActivo: null,
      };

    case types.newRefundSetDashboard:
      return {
        ...state,
        dashboard: action.payload,
      };

    default:
      return state;
  }
};
